{
  "app-frame": {
    "buttons": {
      "be-partner": "For salon owners",
      "login": "Login",
      "logout": "Logout",
      "my-appointments": "My appointments",
      "my-salons": "My salons",
      "profile": "Profile",
      "read": "Read",
      "sign-up": "Sign up",
      "top-salons": "Top Salons"
    },
    "text": {
      "agb-short": "GTC",
      "agb-updated-valid-since": "was updated and will be valid from {{date}}",
      "click-to-read": "Click to read"
    }
  }
}
